export default __webpack_public_path__ + "static/media/british-airways.321a3721.jpg";